import script from "./CommonTable.vue?vue&type=script&setup=true&lang=js"
export * from "./CommonTable.vue?vue&type=script&setup=true&lang=js"

import "./CommonTable.vue?vue&type=style&index=0&id=4d148c04&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d148c04"]])

export default __exports__